/** @module SiteAdmin/DocumentImageRemove **/
define([
	"csi/def",
	"csi/def/ActionFactory",
	"csi/widget/MessageDialog",
	"csi/property/ActionImage",
	"csi/xml"
], function(def,ActionFactory,MessageDialog,ActionImage,xml) {

	return ActionFactory.declare("documentImageRemove", ActionImage, {
		bAllowImageRef: true,
		confirmAction: MessageDialog.BUTTON_REMOVE,
		confirmIcon: MessageDialog.ICON_QUESTION,

		constructor: function(xmlDef) {
			this.m_id = "PropertyImageRemove";
			this.m_class = "iconImageRemove";
			this.m_typeControl = def.ACTION_ICON;
		},

		/**
		 * Determines if the document revision can be deleted
		 * @param {Context} ctx
		 * @return {boolean}
		 */
		hasAccess: function(/*def.Context*/ctx) {
			// summary: determine if selected image can be removed
			var	key = ctx.view.getCurrentImageKey();

			if (key) {
				var docRev = ctx.view.getViewNode();
				var imageURL = docRev.Images[key];
				var imageNode = ctx.cache.getNode(imageURL);

				if (!xml.isEmptyURL(imageNode.GeneratedFor)) {
					return false;
				}
			}

			return key && this.inherited(arguments);
		}
	});
});